// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content___2rAyk","table":"table___2sQP6"};